import ModelEntity from "../../../../../domain/entities/ModelEntity";
import utils from "../../../../../presentation/utils/utils";
import ModelImplDto from "../../../../dto/impl/ModelImplDto";
import HostApi from "../../../../settings/HostApi";
const GetAllModelsOfBrandApiImpl = async (brandId: string): Promise<ModelEntity[]> => {
    let relativeUrl = `/v2/brands/${brandId}`;
    try {
        const response = await HostApi.get(relativeUrl);
        const models = response.map((model: any) => ModelImplDto.fromJson(model));

        return utils.removeDuplicatesByKey(models, "name");
    } catch (error) {
        return [];
    }
};

export default GetAllModelsOfBrandApiImpl;
